import { render, staticRenderFns } from "./Favourites.vue?vue&type=template&id=9ed793c8&scoped=true"
import script from "./Favourites.vue?vue&type=script&lang=js"
export * from "./Favourites.vue?vue&type=script&lang=js"
import style0 from "./Favourites.vue?vue&type=style&index=0&id=9ed793c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ed793c8",
  null
  
)

export default component.exports